import { render, staticRenderFns } from "./ReturnsBoardManagementView.vue?vue&type=template&id=8ad0a25a&"
import script from "./ReturnsBoardManagementView.vue?vue&type=script&lang=js&"
export * from "./ReturnsBoardManagementView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports